export default __webpack_public_path__ + "static/media/logo-mark.c04f523a.svg";